import { render, staticRenderFns } from "./ChatMessages.vue?vue&type=template&id=593101da&scoped=true&"
import script from "./ChatMessages.vue?vue&type=script&lang=js&"
export * from "./ChatMessages.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessages.vue?vue&type=style&index=0&id=593101da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593101da",
  null
  
)

export default component.exports